export default __webpack_public_path__ + "static/media/player-jill-colour-desk.d6e644d8.png";